import {SETTINGS_VIDEOCARDS_UPDATE} from "../../../../constants";

export const updateVideoCardSettings = (id, data) => {
  return {
    type: SETTINGS_VIDEOCARDS_UPDATE,
    id,
    data
  }
};